/*
  Figma "Badge": size S (20px, Caps/Badge 11px) or M (24px, Caps/Menu 13px);
  tones Neutral, Success, Warning, Danger on their status/*-bg fills.
*/
const TONES = {
  neutral: "bg-fill-secondary text-label-primary",
  success: "bg-status-success-bg text-status-success",
  warning: "bg-status-warning-bg text-status-warning",
  danger: "bg-status-danger-bg text-status-danger",
};

const SIZES = {
  s: "h-[20px] px-[6px] text-caps-badge",
  m: "h-[24px] px-space-8 text-caps-menu",
};

const Badge = ({ size = "m", tone = "neutral", children, className = "" }) => (
  <span
    className={`inline-flex shrink-0 items-center justify-center whitespace-nowrap rounded-radius-sm uppercase ${SIZES[size]} ${TONES[tone]} ${className}`}
  >
    {children}
  </span>
);

export default Badge;
